module.exports = __webpack_public_path__ + "img/image001.d908db10.jpg";